module.exports = __webpack_public_path__ + "img/pawn-shop-bg@2x.647dc39d.png";